// Custom module for sentry - used in order to support replays from browser
import * as Sentry from '@sentry/browser';

export default function () {
  return [new Sentry.Replay({
    blockAllMedia: false,
  })];
}
